"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Predefined values
var fontSizesInPx = {
  large: 32,
  "default": 24,
  small: 16
};

var buildStyles = function buildStyles(_ref) {
  var _ref$theme = _ref.theme,
      typography = _ref$theme.typography,
      palette = _ref$theme.palette,
      fontSize = _ref.fontSize;
  return (0, _styledComponents.css)(["font-size:", ";width:inherit;height:inherit;"], typography.pxToRem(fontSizesInPx[fontSize]));
};

var Icon = /*#__PURE__*/(0, _styledComponents["default"])(_Icon["default"]).attrs(function (props) {
  return {
    // className for using Font Awesome
    className: "".concat(props.prefix, "  fa-").concat(props.icon)
  };
}).withConfig({
  displayName: "Icon"
})(["", ""], buildStyles);
Icon.defaultProps = {
  fontSize: 'default',
  color: 'secondary',
  // the default prefix for Font Awesome
  prefix: 'fas'
};
var _default = Icon;
exports["default"] = _default;